<template>
	<label
		class="app-file-input"
		:class="{'app-file-input--disabled' : $attrs.disabled}"
	>
		<input
			type="file"
			class="app-file-input__input"
			:value="value"
			@change="handleInputOnChange"
		>
		<slot></slot>
	</label>
</template>

<script>
export default {
	props: ['value'],
	methods: {
		handleInputOnChange (e) {
			this.$emit('input', e.target.files)
			e.target.type = 'text'
			e.target.type = 'file'
		}
	}
}
</script>

<style lang="scss" scoped>
.app-file-input {
	display: inline-block;
	cursor: pointer;
	position: relative;

	&--disabled {
		pointer-events: none;
		opacity: 0.5;
	}

	&__input {
		position: absolute;
		appearance: none;
		top: 0;
		left: 0;
		width: 0;
		height: 0;
		opacity: 0;
	}
}
</style>
